<template>
  <div>
    <v-card color="grey lighten-4" flat>
      <v-card-text class="scrolling-wrapper" style="height: calc(100vh - 64px);padding-left: 70px; padding-right: 70px;">
        <v-flex xs12 sm12 md12 xl12 style="justify-content: center;display: flex;">
          <v-icon color="black" style="font-size: 60px !important;">feedback</v-icon>
        </v-flex>
        <h1 style="font-size: 24px;display: flex;justify-content: center;" class="CSChatThai"><b>{{$t('Settings.feedback.suggestion')}} </b></h1>
        <div>
          <p style="font-size: 14px;color: black;" class="CSChatThai"><b>
            {{$t('Settings.feedback.headerFeedback')}}
          </b></p>
        </div>
        <div>
          <p style="font-size: 14px;color: black;" class="CSChatThai">{{$t('Settings.feedback.titleFeedback')}} <a href="mailto:onechat@one.th">onechat@one.th</a> {{$t('Conjunction.or')}} <span style="text-decoration: underline; color: #1e88e5; cursor: pointer;" href="javascript:;" @click.stop="conditions = true">{{$t('Settings.feedback.contact')}}</span></p>
          <v-dialog v-model="conditions" width="70%">
            <v-card>
              <v-card-title class="title">{{$t('Settings.feedback.contact')}}</v-card-title>
              <v-card-text v-html="content">
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                flat
                color="blue"
                @click="conditions = false"
                >
                {{$t('AnswerQuestion.ok')}}
              </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <input
          :placeholder="$t('Settings.feedback.name')"
          v-model="name"
          class="InputEdit"
        ></input>
        <br/>
        <br/>
        <div class="InputEdit" style="width: 100%;">
          <v-menu bottom offset-y style="width: 100%; height: 20px; margin-bottom: 7px;">
            <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0; font-size: 14px;">
              <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;text-transform: none; margin-top:12px;" v-if="!title.category_TH">{{$t('Settings.feedback.title')}} </p>
              <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;text-transform: none; margin-top:12px;" v-else>{{($i18n.locale == 'th')? title.category_TH:title.category_ENG }}</p>
              <v-spacer></v-spacer>
              <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
            </v-btn>
            <div style="background: white;height: 300px;">
            <b style="padding: 5px !important;font-size: 15px;color: #2662af;" class="CSChatThai" >{{$t('Settings.feedback.report')}}</b>
            <v-list>
              <v-list-tile v-for="(item, index) in items.list_report"  @click="title = item;" style="background: white;">
                <v-list-tile-title class="CSChatThai" style="font-size: 13px;">
                  {{($i18n.locale == 'th')? item.category_TH:item.category_ENG }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>

            <div style="background: white;">
            <b style="padding: 5px !important;font-size: 15px;color: #2662af;" class="CSChatThai" >{{$t('Settings.feedback.suggestion')}}</b>
            <v-list >
              <v-list-tile v-for="(item, index) in items.list_feedback"  @click="title = item;" style="background: white;">
                <v-list-tile-title class="CSChatThai" style="font-size: 13px;">
                  {{($i18n.locale == 'th')? item.category_TH:item.category_ENG }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </div>
          </div>
          </v-menu>
        </div>
        <br/>
        <v-textarea
          v-model="detail"
          :placeholder="$t('Settings.feedback.detail')"
          counter
          maxlength="255"
          full-width
          class="InputEdit"
          style="height: 120px;resize: none;"
        ></v-textarea>
        <br/>
        <!-- <form ref="fileform" style="float: left;">
          <label>
            <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">{{$t('Settings.feedback.selectPicture')}}</b>
            <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
          </label>
        </form> -->
        <!-- drag drop -->
        <div class="borderfileupload" @dragover="dragover" @dragleave="dragleave" @drop="drop" >
          <input type="file" id="files" ref="files" name="fields[files][]" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
          <div id="files" style="text-align: center; height: 20vh; margin-top: 10px;" v-if="files.length === 0 ">
            <label style="text-align: center; cursor: pointer;" for="files">
              <v-icon color="primary" style="font-size: 40px !important; color: #1a222c;display: flex;justify-content: center;">mdi-package-variant</v-icon>
              <p style="font-size: 13px;">{{$t('Settings.feedback.selcetmultipleImage')}} {{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p>
              <p style="font-size: 13px;">── {{$t('Settings.feedback.or')}} ──</p>
              <div>
                <v-btn
                  color="primary"
                  small 
                  outline
                  @click="openFileimage"
                >
                  {{$t('AnswerQuestion.uploadPhoto')}}
                </v-btn>
              </div>
            </label>
          </div>
          <v-flex xs12 sm12 md12  v-else style="overflow-x: scroll;overflow-y: hidden;height: 30vh !important; width: 100% !important; display: -webkit-inline-box;  padding-top: 10px;" class="containers">
            <div id="files" class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh; padding-top: 10px;">
              <v-icon small style="float: right; padding-right: 10px;" color="primary" @click="removeFile( key )">close</v-icon>
              <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center; margin-top: 25px;">
                <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 15vh !important; width:20vh !important;display: flex;justify-content: center; object-fit: cover;" />
                <b class="text2">{{ file.file.name }}</b>
              </div>
              <div v-else style="text-align: center; display: grid; justify-content: center; margin-top: 25px;" >
                <v-icon style="font-size: 100px !important; color: #1a222c;display: flex; justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                <b class="text2" style="margin-left: 10px;">{{ file.file.name }}</b>
              </div>
            </div>
            <div style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center; display: flex;" v-if="files.length !== 0 && files.length !== 5">
              <v-btn outline color="primary" @click="openFileimage" style="height: 70px; border-radius: 10px;">
                <v-icon style="font-size: 40px;">mdi-image-plus</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </div>
        <!-- close drag -->
        <!-- <v-flex xs12 sm12 md12  v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 30vh !important; width: 100% !important; display: -webkit-inline-box;  padding-top: 3px;" class="containers" @dragover="dragover" @dragleave="dragleave" @drop="drop">
          <div id="files" class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
            <a style="float: right; padding-right: 10px; font-size: 20px;" class="close-classic" @click="removeFile( key )"></a>
            <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center; margin-top:20px;">
              <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 15vh !important; width:15vh !important;display: flex;justify-content: center; object-fit: cover;" />
              <b class="text2">{{ file.file.name }}</b>
            </div>
            <div v-else style="text-align: center; display: grid; justify-content: center;" >
              <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
              <b class="text2">{{ file.file.name }}</b>
            </div>
          </div>
        </v-flex> -->
        <br/>
        <v-layout align-center row justify-center>
          <v-btn dark  color="blue-grey" style="color: white !important;text-transform: none;"  @click="clear()">
            {{$t('AnswerQuestion.cancel')}}
          </v-btn>
          <v-btn dark  color="blue" style="text-transform: none;"  @click="sendfeedback()" v-if="name !== '' && email !== '' && title.category_TH && detail !== ''">
            {{$t('AnswerQuestion.sendme')}}
          </v-btn>
          <v-btn disabled v-else style="text-transform: none;">
              <span >{{$t('AnswerQuestion.sendme')}}</span>
          </v-btn>
        </v-layout>
        <!-- <v-textarea outline
          name="input-1"
          placeholder="ข้อเสนอแนะ"
          textarea
          v-model="comment"
          style="color: black;font-size: 15px;"
          class="CSChatThai"
        ></v-textarea> -->
      </v-card-text>
      <!-- <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark class="btnsendfeed CSChatThai" @click="sendfeedback()">ส่งข้อเสนอแนะ</v-btn>
      </v-card-actions> -->
    </v-card>
  </div>
</template>
<script type="text/javascript">
import { Decode } from '@/services'
var _ = require('lodash')
export default {
  data: () => ({
    files: [],
    name: '',
    email: '',
    phone: '',
    items: [],
    detail: '',
    title: {},
    token: '',
    comment: '',
    status: '',
    conditions: false,
    content: '',
    delimiters: ['${', '}'], // Avoid Twig conflicts
    data: {
      filelist: [] // Store our uploaded files
    },
    // phoneRules: [
    //   v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
    //   v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
    //   v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
    // ],
    // emailRules: [
    //   v => !!v || 'กรุณากรอกอีเมล',
    //   v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
    // ]
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.email = localStorage.getItem('email')
    this.phone = localStorage.getItem('phone')
    this.name = localStorage.getItem('name')
    this.getsubject()
    this.content = '<b>' + this.$t('Settings.helpCenter.company') + '</b> <br>' + this.$t('Settings.helpCenter.address')+' <br>' + this.$t('Settings.helpCenter.email') + ' <a style="text-decoration: none;" href="mailto:onechat@one.th">onechat@one.th</a>'
  },
  watch: {
    files () {
      if (this.files.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.feedback.maxFiles'),
          'warning'
        )
        _.pullAt(this.files, [5])
      }
    }
  },
  methods: {
    openFileimage () {
      this.$refs.files.click()
    },
    remove (i) {
      this.filelist.splice(i, 1);
    },
    dragover (event) {
      event.preventDefault();
    },
    dragleave (event) {
      // Clean up
    },
    drop(event) {
      event.preventDefault();
      this.$refs.files.files = event.dataTransfer.files;
      this.handleFilesUpload(); // Trigger the onChange event manually
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
    // return extension[extension.length-1]
    },
    handleFilesUpload (key) {
      let uploadedFiles = this.$refs.files.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({file: uploadedFiles[i], status: 'waiting'})
      }
      this.getImagePreviews(key)
      document.querySelector('#files').value = ''
    },
    removeFile (key) {
      this.files.splice(key, 1)
      this.getImagePreviews(key)
    },
    getImagePreviews (key) {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(this), false)
          reader.readAsDataURL(this.files[i].file)
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
          // this.$nextTick(function(){
          // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
          // });
          // console.log('mm')
        }
      }
    },
    cancel () {
      // this.name = ''
      this.title = {}
      this.detail = ''
      this.files = []
    },
    clear () {
      if (this.name !== '' || this.title.category_TH || this.detail !== '') {
        this.$swal({
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Clear'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: this.$t('AnswerQuestion.sure'),
          cancelButtonText: this.$t('AnswerQuestion.no'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.cancel()
            // window.open('/login').focus()
            this.$router.push('/login')
          }
        })
      }
    },
    getsubject () {
      this.axios.post(process.env.APImanage + '/getcategory').then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.items = response.data
        }
      })
    },
    sendfeedback () {
      var lengthfile = this.files.length
      if (lengthfile === 0) {
        let formData = new FormData()
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', this.$t('Alert.Success.feedback'), 'success')
          this.cancel()
        }, () => {
          this.$swal('', this.$t('Alert.Fail.feedback.connectError'), 'error')
        })
      } else {
        this.sendfeedbackfile()
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackfile () {
      let formData = new FormData()
      var lengthfile = this.files.length
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file
        formData.append('file', file, file.name)
      }
      // console.log(formData)
      formData.append('phone', this.phone)
      formData.append('email', this.email)
      formData.append('comment', this.detail)
      formData.append('name', this.name)
      formData.append('category_id', this.title.category_id)
      this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
        // console.log(response.data)
        this.$swal('', this.$t('Alert.Success.feedback'), 'success')
        this.cancel()
      }, () => {
        this.$swal('', this.$t('Alert.Fail.feedback.connectError'), 'error')
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.text2 {
  white-space: nowrap;
  width: 20vh;
  overflow: hidden;
  text-overflow: ellipsis;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.containers {
  width: 576px; margin: 0 auto;
}
.containers:after {
  content: '';
  display: block;
  clear: both;
}
.borderfileupload {
  border: 1px solid #00000036;
  border-radius: 5px;
  /* width: 15vw !important;
  height: 25vh !important; */
  position: relative;
  background: white;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 15vw !important;
  height: 25vh !important;
  position: relative;
  background: white;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
}
/*>>>.v-text-field.v-text-field--enclosed {
  margin: 0;
  width: 100%;
  padding: 0;
}
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
  width: 100%;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none;
}
>>>.v-input__slot {
  border-width: thin;
  border-style: solid;
  border-color: #d2d8dd;
  border-radius: 4px;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.btnsendfeed {
  width: 100%;
  color: white;
  border-radius: 5px;
}
a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/settings/Feedback.vue